import { difference } from 'lodash'

export default {
  activeDoc: (state) => state.documents[state.activeDocId],
  activeDocId: (state) => state.activeDocId,
  activeFolder: (state) => state.activeFolder,
  activeModal: (state) => state.activeModal,
  activeReviewState: (state) => state.activeReviewState,
  activeCheckAll: (state) => state.activeCheckAll,
  activeOrSelectedDocIds: (state) =>
    state.activeDocId !== '' && state.checkedDocIds.length === 0
      ? [state.activeDocId]
      : difference(state.checkedDocIds, state.processingDocIds),
  autoSaveState: (state) => state.autoSaveState,
  checkedDocIds: (state) => state.checkedDocIds,
  checkedDocIdsCount: (state) => state.checkedDocIds.length,
  folders: (state) => state.folders,
  folderOptions: (state) => state.folderOptions,
  getDocuments: (state) => state.documents,
  getDocument: (state) => (id) => state.documents[id],
  infiniteId: (state) => state.infiniteId,
  infinitePage: (state) => state.infinitePage,
  processingDocIds: (state) => state.processingDocIds,
  prettyId: (state) => state.prettyId,
  markupUpdatedAt: (state) => state.currentMarkupUpdatedAt,
  reviewStateCounts: (state) => state.reviewStateCounts,
  searchTerm: (state) => state.searchTerm,
  searchProcesses: (state) => state.searchProcesses,
  viewingSessionId: (state) => state.viewingSessionId,
  totalDocCount: (state) => state.totalDocCount
}
